import { useRef, useEffect } from 'react';

const useInterval = (callback: () => any, delay?: number) => {
  const savedCallback = useRef<() => any>(() => null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return () => null;
  }, [delay]);
};

export default useInterval;
